<mat-checkbox [(ngModel)]="value">
  {{ getLabel }}
</mat-checkbox>
